import React from 'react';
import { connect } from 'react-redux';
import {
  activeRoute,
  deactiveRoute,
  addHomes,
  subtractHome,
  addCost,
  subtractCost,
  addBusiness,
  subtractBusiness
} from '../actions';

class ElementTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false
    };
  }

  handleTableClick = (event) => {
    event.preventDefault();

    const {
      route,
      activeRoute,
      deactiveRoute,
      addHome,
      subtractHome,
      addCost,
      subtractCost,
      addBusiness,
      subtractBusiness
    } = this.props;

    const graphic = route.attributes.graphic;
    if (!graphic) return;

    if (graphic.selected) {
      graphic.symbol = graphic.offSymbol;
      graphic.selected = false;

      deactiveRoute(route.attributes.ZIP_CRID);
      subtractHome(route.attributes.RES_CNT);
      subtractCost(route.attributes.TOT_CNT);
      subtractBusiness(route.attributes.BUS_CNT);
    } else {
      graphic.symbol = graphic.selectedSymbol;
      graphic.selected = true;
      graphic.hovered = false;

      activeRoute(route.attributes.ZIP_CRID);
      addHome(route.attributes.RES_CNT);
      addCost(route.attributes.TOT_CNT);
      addBusiness(route.attributes.BUS_CNT);
    }

    this.setState((prevState) => ({
      active: !prevState.active
    }));
  };

  render() {
    const { route, actived } = this.props;

    return (
      <tr
        onClick={this.handleTableClick}
        style={{ color: 'white', backgroundColor: '#e7158d', cursor: 'pointer' }}
        className={actived ? 'table-primary' : ''}
      >
        <th scope="row" style={{ border: '0px' }}>
          {route.attributes.ZIP_CODE}-{route.attributes.CRID_ID}
        </th>
        <td style={{ border: '0px' }}>{route.attributes.RES_CNT}</td>
        <td style={{ border: '0px' }}>{route.attributes.BUS_CNT}</td>
        <td style={{ border: '0px' }}>{route.attributes.TOT_CNT}</td>
        <td style={{ border: '0px' }}>
          {(route.attributes.AVG_HH_SIZ || 0).toFixed(2)}
        </td>
        <td style={{ border: '0px' }}>
          {route.attributes.MED_INCOME
            ? `$${(route.attributes.MED_INCOME * 1).toLocaleString()}`
            : '--'}
        </td>
      </tr>
    );
  }
}

export default connect(null, {
  activeRoute,
  deactiveRoute,
  addHome: addHomes,
  subtractHome,
  addCost,
  subtractCost,
  addBusiness,
  subtractBusiness
})(ElementTable);